import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Modal, BlockStack, Button, Banner } from "@shopify/polaris";
import "./index.scss";
import Language from "../../i18n/Language";
import { store } from "../../redux/store";
import { reqGetNewUserPricingPlanList, reqGetSubscription } from "../../api";
import { connect } from "react-redux";
import { setPageData } from "../../redux/actions/getAppPageData";
import utils from "../../utils/utils";
const t = Language;

class indexClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // 自定义弹窗内容
            isCustomize: this.props.isCustomize,
            cusTitle: this.props.cusTitle,
            cusServerList: this.props.cusServerList,

            upgradeModalShow: this.props.upgradeModalShow,
            level: this.props.level,
            userinfo: {},
            serversList: [
                {
                    id: 1,
                    status: 0,
                    plan: 1,
                    name: "lmage Compress",
                    func: ["50 images/month", "2000 images/month", "6000~26000 images/month"],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Add instant page",
                    isText: true,
                },
                {
                    id: 2,
                    status: 0,
                    plan: 1,
                    name: "Site Speed Up",
                    func: ["Basic", "Fast⚡", "Rocket⚡⚡"],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Add instant page",
                    isText: true,
                },
                {
                    id: 3,
                    status: 0,
                    plan: 1,
                    name: "Exchange Backlink",
                    func: ["40 quota", "300 quota", "1000 quota"],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Add instant page",
                    isText: true,
                },
                {
                    id: 4,
                    status: 0,
                    plan: 1,
                    name: "On-page SEO Optimization",
                    func: ["20 quota", "1000 quota", "Unlimited quota"],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Add instant page",
                    isText: true,
                },
                {
                    id: 5,
                    status: 0,
                    plan: 1,
                    name: "View page ranking",
                    func: ["10 pages", "500 pages", "1500 pages"],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Add instant page",
                    isText: true,
                },
                {
                    id: 6,
                    status: 0,
                    plan: 1,
                    name: "AI credits",
                    func: ["30 credits", "200 credits/month", "500 credits/month"],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Add instant page",
                    isText: true,
                },
                {
                    id: 7,
                    status: 0,
                    plan: 1,
                    name: "Auto repair broken links",
                    func: [0, 1, 1],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Add instant page",
                    isText: false,
                },
                {
                    id: 8,
                    status: 0,
                    plan: 1,
                    name: "Auto-optimization Meta Tags",
                    func: [0, 1, 1],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Add instant page",
                    isText: false,
                },
                {
                    id: 9,
                    status: 0,
                    plan: 1,
                    name: "Google Analytics&instant index",
                    func: [0, 1, 1],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Add instant page",
                    isText: false,
                },
                {
                    id: 10,
                    status: 0,
                    plan: 1,
                    name: "Google structured data&Local Business",
                    func: [0, 1, 1],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Add instant page",
                    isText: false,
                },
                {
                    id: 11,
                    status: 0,
                    plan: 1,
                    name: "AMP",
                    func: [0, 0, 1],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Add instant page",
                    isText: false,
                },
                {
                    id: 12,
                    status: 0,
                    plan: 1,
                    name: "Monitor your website's backlinks&keywords",
                    func: [0, 0, 1],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Add instant page",
                    isText: false,
                },
                {
                    id: 13,
                    status: 0,
                    plan: 1,
                    name: "Advanced competitor keyword research",
                    func: [0, 0, 1],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Add instant page",
                    isText: false,
                },
            ],
            // 价格及升级信息
            userInfo: {},                                        // 用户套餐信息
            proPrice: 1,
            prePrice: 1,
            proId: 1,
            preId: 1,
            proDiscount: 1,
            preDiscount: 1,
            proDiscountPrice: '',
            preDiscountPrice: '',
            proMRecode: '',                                          // 折扣码
            preMRecode: '',
            proYRecode: '',
            preYRecode: '',
            upgradeBtn: false,
            loading: true,
            creditsShow: this.props.creditsShow,
        };
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.level !== this.props.level) {
            this.setState({
                level: nextProps.level
            })
        }
        if (nextProps.upgradeModalShow !== this.props.upgradeModalShow) {
            this.setState({
                upgradeModalShow: nextProps.upgradeModalShow
            })
        }
        if (nextProps.creditsShow !== this.props.creditsShow) {
            this.setState({
                creditsShow: nextProps.creditsShow
            })
        }

        return true;
    }

    componentDidMount() {
        let _page = store.getState().page;
        let { isCustomize, serversList, cusServerList } = this.state;
        let newServerList = isCustomize ? cusServerList : serversList;
        this.setState({
            level: _page.level || 1,
            trial_days: _page.trial_days || 0,
            domain: _page.domain || '',
            serversList: newServerList
        }, () => {
            this.getUserPricingPlanList(_page.pageInit?.pricingPlan);
        })
    }

    // 获取价格套餐版本
    getUserPricingPlanList = async (cache = null) => {
        let params = {};
        let _actData = store.getState().public.ActMealData;
        if (Object.keys(_actData).length > 0) {
            params['activity_id'] = _actData.activity_id;
            let response = cache || await reqGetNewUserPricingPlanList(params);
            this.props.getPageDataRedux(response);
            if (response.ack === 1) {
                let res = response.data;
                let monthPlan = res.meal_list.month;
                this.setState({
                    pricingPlanList: res.meal_list,
                    loading: false,
                    level: res.level,
                    pricingData: res,
                    userInfo: {
                        ppid: res.ppid,
                        level: res.level,
                        trial_days: res.trial_days
                    },
                    planName: store.getState().public.ActMealData.plan_name || '',
                    isHaveDiscount: res.coupon_fifty_discount,   // 是否存在折扣
                    proPrice: monthPlan[0].price,
                    prePrice: monthPlan[1].price,
                    proId: monthPlan[0].id,
                    preId: monthPlan[1].id,
                    proDiscount: Number(monthPlan[0]?.coupon_info?.rate) === 0 ? '' : Number(monthPlan[0]?.coupon_info?.rate),
                    preDiscount: Number(monthPlan[1]?.coupon_info?.rate) === 0 ? '' : Number(monthPlan[1]?.coupon_info?.rate),
                    proDiscountPrice: (monthPlan[0].discount_exp > new Date().getTime() / 1000) ? (Boolean(monthPlan[0].discount_price) ? (Number(monthPlan[0].discount_price) === 0 ? 0 : Number(monthPlan[0].discount_price)) : -1) : -1,
                    preDiscountPrice: (monthPlan[1].discount_exp > new Date().getTime() / 1000) ? (Boolean(monthPlan[1].discount_price) ? (Number(monthPlan[1].discount_price) === 0 ? 0 : Number(monthPlan[1].discount_price)) : -1) : -1,
                }, () => {
                    // 是否更新
                    // if (cache) {
                    //     this.getUserPricingPlanList();
                    // }

                    // 判断优惠力度 计算使用哪个折扣周期
                    let monthProPrice = monthPlan[0].price;
                    let monthPrePrice = monthPlan[1].price;
                    let prodisType = '', predisType = '';
                    let mPro = monthPlan[0], mPre = monthPlan[1];
                    // pro plan
                    if (Boolean(mPro?.discount_period >= 0) && Boolean(mPro?.coupon_info?.discount_period >= 0)) {
                        if (!Boolean(Number(mPro['coupon_info']['rate'])) && Number(mPro['coupon_info']['rate']) < 0) {
                            if (Number(mPro['discount_price']) >= 0) {
                                prodisType = 'discount';
                            }
                        } else if (Number(mPro['coupon_info']['rate']) >= 0 && Number(mPro['coupon_info']['rate']) < 1) {
                            if (Number((Number(Number(mPro['coupon_info']['rate'])) * monthProPrice).toFixed(2)) >= Number(mPro['discount_price']) && Boolean(mPro['discount_price'] >= 0)) {
                                prodisType = 'discount';
                            } else {
                                prodisType = 'code';
                            }
                        } else if (Number(mPro['coupon_info']['rate']) >= 1) {
                            if (Number(monthProPrice - Number(mPro['coupon_info']['rate'])) >= Number(mPro['discount_price']) && Boolean(mPro['discount_price'] >= 0)) {
                                prodisType = 'discount';
                            } else {
                                prodisType = 'code';
                            }
                        } else {
                            prodisType = '';
                        }
                    } else {
                        if (Boolean(mPro?.discount_period >= 0)) {
                            prodisType = 'discount';
                        }
                        if (Boolean(mPro?.coupon_info?.discount_period >= 0)) {
                            prodisType = 'code';
                        }
                    }
                    // pre plan
                    if (Boolean(mPre?.discount_period >= 0) && Boolean(mPre?.coupon_info?.discount_period >= 0)) {
                        if (!Boolean(Number(mPre['coupon_info']['rate'])) && Number(mPre['coupon_info']['rate']) < 0) {
                            if (Number(mPre['discount_price']) >= 0) {
                                predisType = 'discount';
                            }
                        } else if (Number(mPre['coupon_info']['rate']) >= 0 && Number(mPre['coupon_info']['rate']) < 1) {
                            if (Number((Number(Number(mPre['coupon_info']['rate'])) * monthPrePrice).toFixed(2)) >= Number(mPre['discount_price']) && Boolean(mPre['discount_price'] >= 0)) {
                                if (mPre.discount_period < mPre.coupon_info.discount_period) {
                                    predisType = 'code';
                                } else {
                                    predisType = 'discount';
                                }
                            } else {
                                predisType = 'code';
                            }
                        } else if (Number(mPre['coupon_info']['rate']) >= 1) {
                            if (Number(monthPrePrice - Number(mPre['coupon_info']['rate'])) >= Number(mPre['discount_price']) && Boolean(mPre['discount_price'] >= 0)) {
                                if (mPre.discount_period < mPre.coupon_info.discount_period) {
                                    predisType = 'code';
                                } else {
                                    predisType = 'discount';
                                }
                            } else {
                                predisType = 'code';
                            }
                        } else {
                            predisType = '';
                        }
                    } else {
                        if (Boolean(mPre?.discount_period >= 0)) {
                            predisType = 'discount';
                        }
                        if (Boolean(mPre?.coupon_info?.discount_period >= 0)) {
                            predisType = 'code';
                        }
                    }
                    if (Boolean(monthPlan[1]?.coupon_info?.expires_in) && predisType === 'code') {
                        this.setState({
                            preMRecode: monthPlan[1].coupon_info.code
                        })
                    }
                    if (Boolean(monthPlan[0]?.coupon_info?.expires_in) && prodisType === 'code') {
                        this.setState({
                            proMRecode: monthPlan[0].coupon_info.code
                        })
                    }
                })
            } else {
                this.props.toggleToast(response.msg, true);
            }
        } else {
            setTimeout(() => {
                this.getUserPricingPlanList(cache);
            }, 500)
        }
    }

    // 开关弹窗
    closeCompareModal = () => {
        let { upgradeBtn } = this.state;
        if (!Boolean(upgradeBtn)) {
            this.setState({
                upgradeModalShow: false
            }, () => {
                this.props.changeUpgradeState();
            })
        }
    }

    // 切换版本套餐
    handleUpdatePricingMeal = (type) => {
        // 判断是否cw组合付费用户
        let isComboUser = store.getState().public.isComboUser;
        if (isComboUser) {
            // cw组合付费用户
            this.setState({
                isShowCwComboModal: true
            })
        } else {
            this.setState({
                upgradeBtn: type
            }, async () => {
                let { proPrice, prePrice, proId, preId, proDiscount, preDiscount, proDiscountPrice, preDiscountPrice } = this.state;
                // 计算最后的提交价格
                let endPrice = 0;
                let isGetDiscount = false;
                let isGetCodeDiscount = false;
                let disObject = {
                    discount: type === 'pro' ? proDiscount : preDiscount,
                    actMealDiscount: type === 'pro' ? proDiscountPrice : preDiscountPrice,
                }
                let price = type === 'pro' ? proPrice : prePrice;
                let id = type === 'pro' ? proId : preId;
                // 判断优惠力度
                if (!Boolean(disObject.discount) && (Number(disObject.discount) < 0 || isNaN(disObject.discount))) {
                    // 优惠折扣
                    if (disObject.actMealDiscount > 0) {
                        endPrice = disObject.actMealDiscount;
                        isGetDiscount = true;
                    } else {
                        endPrice = price;
                    }
                } else if (Number(disObject.discount) >= 0 && Number(disObject.discount) < 1) {
                    if (Number((Number(Number(disObject.discount)) * price).toFixed(2)) >= disObject.actMealDiscount && Boolean(disObject.actMealDiscount >= 0)) {
                        endPrice = disObject.actMealDiscount;
                        isGetDiscount = true;
                    } else {
                        endPrice = Number((Number(Number(disObject.discount)) * price).toFixed(2));
                        isGetCodeDiscount = true;
                        // endPrice = price;
                    }
                } else if (Number(disObject.discount) >= 1) {
                    if (Number(price - Number(disObject.discount)) >= disObject.actMealDiscount && Boolean(disObject.actMealDiscount >= 0)) {
                        endPrice = disObject.actMealDiscount;
                        isGetDiscount = true;
                    } else {
                        endPrice = Number(price - Number(disObject.discount));
                        isGetCodeDiscount = true;
                        // endPrice = price;
                    }
                } else {
                    endPrice = price;
                }
                let params = {
                    ppid: id,
                    price: Number(endPrice),
                    is_verify: 0,
                }
                if (isGetDiscount) {
                    // 活动折扣
                    let ppList = this.state.pricingPlanList;
                    let list_plan = [...ppList['free'], ...ppList['month'], ...ppList['year']];
                    params['activity_id'] = list_plan.filter(item => item.id === id)[0].activity_id;
                }
                if (isGetCodeDiscount) {
                    // 优惠券折扣
                    let { proMRecode, preMRecode, proYRecode, preYRecode } = this.state;
                    params['coupon_code'] = id === 2 ? proMRecode : id === 4 ? preMRecode : id === 8 ? proYRecode : id === 9 ? preYRecode : proMRecode;
                }
                const res = await reqGetSubscription(params);
                if (res.ack === 1) {
                    this.props.toggleToast(res.msg, false);
                    //跳转支付页面
                    let j_url = res.data.jump_url;
                    if (j_url) {
                        if (window.top) {
                            window.top.location.href = j_url;
                        } else {
                            this.handleJumpSubUrl(j_url);
                        }
                    }
                } else {
                    // 老用户一次性付费
                    if (res.code === 202) {
                        this.setState({
                            upgradeBtn: false
                        })
                    } else {
                        this.setState({
                            upgradeBtn: false,
                        }, () => {
                            this.props.toggleToast(res.msg, true);
                        })
                    }
                }
            })
        }
    }

    // 监听支付跳转
    handleJumpSubUrl = (j_url) => {
        if (window.top) {
            window.top.location.href = j_url;
        } else {
            setTimeout(() => {
                this.handleJumpSubUrl(j_url);
            }, 5000)
        }
    }

    // 关闭
    closeComboModal = () => {
        this.setState({
            isShowCwComboModal: false
        })
    }

    // 跳转价格页
    jumpPricing = () => {
        const url = "/plan";
        if (window.opener) {
            this.handleModalToMain(url);
        } else {
            utils.routeJump(this, url);
        }
    }

    // 跳转cw集合页
    goSolutionExpert = () => {
        const url = "/settings";
        const _query = { selected: "Solutionexpert", tabkey: 4 };
        if (window.opener) {
            this.handleModalToMain(url, null, _query);
        } else {
            utils.routeJump(this, url, null, _query);
        }
    }

    // 判断是否内嵌及退出全屏
    handleModalToMain = (url, state = null, query = null) => {
        const pathUrl = window.location.pathname;
        let modal = pathUrl.indexOf("/speedOpt/seo-ant-amp/custome") > -1 ? "AMP_Customize_Modal" :
            pathUrl.indexOf("/on-page-seo/detail") > -1 ? "OnpageAI_Modal" :
                pathUrl.indexOf("/on-page-seo/generate-blog") > -1 ? "OnpageBlog_Modal" : null;
        this.sendDataToMain(url, modal, state, query);
    }

    // 传递参数到主窗口
    sendDataToMain = (url, objs, _state, _query) => {
        const _winOpr = window.opener;
        if (_winOpr) {
            _winOpr.postMessage({ mode: "UpgradeOpener", url, objs, _state, _query }, window.location.origin);    // 传递数据到主窗口
        }
    }

    render() {
        const {
            upgradeModalShow,
            upgradeBtn,
            serversList,
            loading,
            userInfo,
            isCustomize,
            cusTitle,
            isShowCwComboModal,
            creditsShow,
        } = this.state;

        // 路由
        const pathUrl = window.location.pathname || '';

        // cw组合套餐提示弹窗
        const CWComboModal = <Modal
            open={isShowCwComboModal}
            title={t("Plan reminder")}
            primaryAction={{
                content: t("Go to view"),
                onAction: this.goSolutionExpert,
            }}
            secondaryActions={[
                {
                    content: t("Close"),
                    onAction: this.closeComboModal
                }
            ]}
            onClose={this.closeComboModal}
        >
            <Modal.Section>
                <p>{t("You are currently using Channelwill's package, please update your plan on the package page")}</p>
            </Modal.Section>
        </Modal>

        // 内容返回
        const pricingMainContent = (data) => {
            return (data.func).map((item, index) => {
                return Boolean(data?.isText) ? <span key={index}>
                    {
                        item.includes("Unlimited") ? <span>
                            <span style={{ color: "#7B45EC" }}>{t("Unlimited")}</span>&nbsp;
                            {t(item.split(" ")[1])}
                        </span> :
                            item.includes("quota") ? `${t(item.split(" ")[0])} ${t("quota")}` :
                                item.includes("pages") ? `${t(item.split(" ")[0])} ${t("pages")}` :
                                    item.includes("images/month") ? `${t(item.split(" ")[0])} ${t("images/month")}` :
                                        t(item)
                    }
                </span> : <span key={index}>{Boolean(item) ? getIcon : null}</span>
            })
        }

        // 付费版本比较弹窗
        const getIcon = <svg width="15" height="15" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.2803 6.03033C10.5732 5.73744 10.5732 5.26256 10.2803 4.96967C9.98744 4.67678 9.51256 4.67678 9.21967 4.96967L6.25 7.93934L5.03033 6.71967C4.73744 6.42678 4.26256 6.42678 3.96967 6.71967C3.67678 7.01256 3.67678 7.48744 3.96967 7.78033L5.71967 9.53033C6.01256 9.82322 6.48744 9.82322 6.78033 9.53033L10.2803 6.03033Z" fill="#303030" />
            <path fillRule="evenodd" clipRule="evenodd" d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM12.5 7C12.5 10.0376 10.0376 12.5 7 12.5C3.96243 12.5 1.5 10.0376 1.5 7C1.5 3.96243 3.96243 1.5 7 1.5C10.0376 1.5 12.5 3.96243 12.5 7Z" fill="#303030" />
        </svg>
        const UpgradePlanModalHtml = <Modal
            // size="large"
            open={Boolean(upgradeModalShow)}
            title={
                pathUrl.indexOf("generate-blog") > -1 ? t("Plan Comparison") :
                    isCustomize ? cusTitle : upgradeModalShow === 'pro' ? t("Available in Pro") : t("Available in Pre")
            }
            primaryAction={upgradeModalShow && upgradeModalShow !== 'all' ? [
                {
                    content: (userInfo?.trial_days > 0) ? t("Try Pre for {{v1}} Days", userInfo?.trial_days) : t("Upgrade to Pre"),
                    onAction: () => this.handleUpdatePricingMeal("pre"),
                    loading: loading || Boolean(upgradeBtn === 'pre'),
                }
            ] : [
                {
                    content: t("OK"),
                    onAction: this.closeCompareModal
                }
            ]}
            secondaryActions={upgradeModalShow === 'pro' ? [
                {
                    content: (userInfo?.trial_days > 0) ? t("Try Pro for {{v1}} Days", userInfo?.trial_days) : t("Upgrade to Pro"),
                    onAction: () => this.handleUpdatePricingMeal("pro"),
                    loading: loading || Boolean(upgradeBtn === 'pro'),
                },
            ] : []}
            onClose={this.closeCompareModal}
        >
            <Modal.Section>
                <div className="compare_plan_main">
                    <BlockStack gap={200}>
                        {
                            creditsShow && <Banner
                                title={t("Your AI credit balance is insufficient")}
                                tone="warning"
                            >
                            </Banner>
                        }
                        <img src="/coupon/npre_plan.png" alt='' />
                    </BlockStack>
                    <BlockStack gap={300}>
                        <div className="cp_list">
                            <div className="cp_flex cp_title">
                                <span className="cp_main_name"></span>
                                <span>{t("Basic")}</span>
                                <span>{t("Pro")}{isCustomize ? '⚡️' : ''}</span>
                                <span>{t("Pre")}{isCustomize ? '⚡️⚡️' : ''}</span>
                            </div>
                            <div className="cp_main">
                                {
                                    serversList.map(item => {
                                        return <div className="cp_flex cp_main_item" key={item.id}>
                                            <span className="cp_main_name">{t(item.name)}</span>
                                            {pricingMainContent(item)}
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    </BlockStack>
                    <p className="get_overview">{t("Get a Complete Overview of")} <Button variant="plain" onClick={this.jumpPricing}>{t("All Plan Features")}</Button></p>
                </div>
            </Modal.Section>
        </Modal>

        return <div>
            {UpgradePlanModalHtml}
            {CWComboModal}
        </div>;
    }
}


const mapStateToProps = state => {
    return state
}
const mapDispatchToProps = dispatch => ({
    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['pricingPlan', data]));
    },
})

indexClass = connect(
    mapStateToProps,
    mapDispatchToProps
)(indexClass);

export default withRouter(indexClass);